import React from "react";
import { useNavigate } from "react-router-dom";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BRANCH_ADMIN } from "common/constants/constants";
import { checkRole } from "utils/Utils";

import { CommonButton } from "../button/Button";
import { useTranslation } from "react-i18next";
const BranchDataStatusModal = ({ handleClose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div>
      <div className="d-flex justify-content-between pb-5">
        <h3>{t("missing-data")}</h3>
        <FontAwesomeIcon
          icon={faTimes}
          size="12px"
          onClick={handleClose}
          style={{ cursor: "pointer" }}
        />
      </div>
      <p>{t("missing-data-text-1")}</p>
      <p>{t("missing-data-text-2")}</p>
      <div className="d-flex justify-content-end pt-5">
        <CommonButton
          click={handleClose}
          title={t("cancel")}
          borderRadius="5px"
          bgColor="#ffff"
          color="#000"
          hoverBgColor="#ffff"
        />
        {checkRole() === BRANCH_ADMIN && (
          <CommonButton
            click={() => navigate("/branch-detail")}
            title={t("go-to-upload")}
            border="none"
            borderRadius="5px"
            margin="0 0 0 10px "
          />
        )}
      </div>
    </div>
  );
};

export default BranchDataStatusModal;
